module.exports = __webpack_public_path__ + "img/gray-privilege.6c539f74.png";